"use strict";

angular
  .module("broadcastsModule", [
    "ngKomondorMediaLibrary",
    "ngKomondorResourceView",
  ])

  .factory("Broadcast", [
    "DS",
    "$state",
    function (DS, $state) {
      return DS.defineResource({
        name: "Broadcast",
        endpoint: "broadcasts",
        defaultValues: {
          action_id: 0,
          folder_id: 0,
        },
        methods: {
          goInto: function goInto() {
            if (this.type === "folder") {
              $state.go("admin.broadcasters", {
                folder_id: this.id,
                offset: null,
                name: null,
              });
            } else {
              $state.go("admin.broadcasters.preview", { id: this.id });
            }
          },
        },
      });
    },
  ])

  .factory("BroadcastsUploader", [
    "FileUploader",
    "$cookies",
    function (FileUploader, $cookies) {
      return function (options) {
        return new FileUploader(
          angular.extend(
            {
              url: "/api/broadcast-files",
              withCredentials: true,
              headers: { "X-XSRF-TOKEN": $cookies.get("XSRF-TOKEN") },
            },
            options
          )
        );
      };
    },
  ]);

angular
  .module("ngKomondorMediaLibrary")
  .factory("broadcastsViewOptions", [
    "$rootScope",
    "$state",
    "$q",
    "extendDeep",
    "Asset",
    "resourceViewOptions",
    "moveAction",
    "listNameTemplate",
    "gridThumbTemplate",
    "gridNameTemplate",
    "createFolderAction",
    function (
      $rootScope,
      $state,
      $q,
      extendDeep,
      Asset,
      resourceViewOptions,
      moveAction,
      listNameTemplate,
      gridThumbTemplate,
      gridNameTemplate,
      createFolderAction
    ) {
      var mediaOptions = angular.copy(resourceViewOptions);
      var createFolder = angular.copy(createFolderAction);
      mediaOptions.actions.push(moveAction);
      mediaOptions.sorts = [
        {
          label: "Type",
          sort: "type asc,name asc",
        },
      ];
      mediaOptions.toolbar = [createFolder];
      mediaOptions.toolbar.push({
        name: "upload",
        buttonClass: "btn btn-primary",
        template: '<i class="material-icon material-icon-upload"></i> Upload',
        act: function act() {
          $state.go(".upload");
        },
        show: function show() {
          return true;
        },
      });
      //rowClassifier - allows assignment of classes to wrapping row
      //onItemClick - delegated click handler (perscribe behaviour when click on asset)
      //list - injectable html + configuration options
      //grid - injectable html
      extendDeep(mediaOptions, {
        tagging: false,
        viewIndex: 1,
        queryDefaults: { where: { folder_id: 0 } },
        rowClassifier: function rowClassifier(row, classes) {
          return classes;
        },
        onItemClick: function onItemClick($event, model) {
          $event.stopPropagation();
          model.goInto();
        },
        list: {
          columns: [
            {
              label: "Name",
              name: "name",
              template: listNameTemplate("name", "links.thumb", "type"),
              sortable: true,
            },
            {
              label: "Size",
              name: "size",
              template:
                '<span class="resource-ui-filesize">{{ model.size | bytes }}</span>',
              sortable: false,
            },
            {
              label: "Format",
              template:
                '<span class="resource-ui-filetype">{{ model.format.join(", ") }}</span>',
              sortable: false,
            },
            {
              label: "Last modified",
              name: "updated_at",
              template: "<span>{{ model.updated_at | date }}</span>",
              sortable: true,
            },
          ],
        },
        grid: {
          fields: [
            {
              template: gridThumbTemplate("links.thumb", "type"),
            },
            {
              template: gridNameTemplate("name", null),
            },
          ],
        },
      });
      return mediaOptions;
    },
  ])
  .run(["BroadcastsFile", function (BroadcastsFile) {}]) // jshint ignore:line
  .factory("BroadcastsFile", [
    "DS",
    function (DS) {
      return DS.defineResource({
        name: "BroadcastsFile",
        endpoint: "broadcast-files",
      });
    },
  ])
  .run(["BroadcastsAsset", function (BroadcastsAsset) {}]) // jshint ignore:line
  .factory("BroadcastsAsset", [
    "DS",
    "$state",
    function (DS, $state) {
      return DS.defineResource({
        name: "BroadcastsAsset",
        endpoint: "broadcasts",
        defaultValues: {
          action_id: 0,
          folder_id: 0,
        },
        methods: {
          goInto: function goInto() {
            if (this.type === "folder") {
              $state.go("admin.broadcasters", {
                folder_id: this.id,
                offset: null,
                name: null,
              });
            } else {
              $state.go("admin.broadcasters.preview", { id: this.id });
            }
          },
        },
      });
    },
  ]);
